const normalizePermissionName = (permissionName = "") =>
  String(permissionName).trim().toLowerCase();

export const createViewPagePermission = (pageName = "") =>
  `view ${String(pageName).trim().toLowerCase()} page`;

export const buildPermissionSet = (permissions = []) =>
  new Set(
    permissions
      .map((permission) => normalizePermissionName(permission?.name))
      .filter(Boolean)
  );

export const hasRoutePermission = (route, permissionSet) => {
  if (!route) return false;
  if (route.publicAccess === true || route.requiredPermission === null) return true;

  const permissionToCheck =
    route.requiredPermission ||
    createViewPagePermission(route.permissionName || route.name);

  if (!permissionToCheck || !permissionToCheck.trim()) return false;

  return permissionSet.has(normalizePermissionName(permissionToCheck));
};
